import React, { memo } from 'react'

import { useIsTabletS, useIsMobileXL } from '@hooks/use-media-query'

import { Wrapper, Title } from './styles'

function CaseHeaderComponent({
  title,
  titleMobile,
  titleColor,
  titleColorMobile,
  mobileFont,
}) {
  const isAboveTabletS = useIsTabletS()
  const isMobileXL = useIsMobileXL()
  const color =
    !isAboveTabletS && titleColorMobile ? titleColorMobile : titleColor

  const currentTitle = isMobileXL && titleMobile ? titleMobile : title

  return (
    <Wrapper>
      {title && (
        <Title color={color} $mobileFont={mobileFont} as="h2">
          {currentTitle || title}
        </Title>
      )}
    </Wrapper>
  )
}

export const CaseHeader = memo(CaseHeaderComponent)
